
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { ModalState } from '@/core/types/modal-state';

const TEST_ID = 'Kloans-Login-MobileAppReminderModal';

@Component
export default class MobileAppReminderModal extends Vue {
	public TEST_ID = TEST_ID;

	public isLoading = false;

	public isAndroid = false;

	public isApple = false;

	public isShown = false;

	@Prop({ default: { isShown: false, isLoading: false } })
	public state!: ModalState;

	@Watch('state')
	public watchState(state: { isShown: boolean; isLoading: boolean }): void {
		this.isShown = state.isShown;
		this.isLoading = !!state.isLoading;
	}

	mounted() {
		if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
			this.isAndroid = true;
		}
		if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) {
			this.isApple = true;
		}
	}

	public close(): void {
		this.isShown = false;
		this.isLoading = false;
	}
}
